module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_1@3x.07a9d117.png";